/* eslint-disable @typescript-eslint/no-unused-vars */
import { FC, useEffect, useState } from 'react';

import classNames from 'classnames';

import styles from './Hamburger.module.css';

interface Props {
  isActive: boolean;
  showAnim: boolean;
  isOpenMenu: boolean;
  handleClick: () => void;
}

type HamburgerClasses = {
  line1: string;
  line2: string;
  line3: string;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const IconHamburger: FC<Props> = ({
  isActive,
  handleClick,
  showAnim,
  isOpenMenu,
}) => {
  const [handleClassWithAnim, setHandleClassWithAnim] =
    useState<HamburgerClasses>({
      line1: '',
      line2: '',
      line3: '',
    });
  useEffect(() => {
    if (isOpenMenu) {
      setHandleClassWithAnim({
        line1: '',
        line2: '',
        line3: '',
      });
      setTimeout(() => {
        setHandleClassWithAnim({
          line1: styles.line1Active,
          line2: styles.line2Active,
          line3: styles.line3Active,
        });
      }, 10);
    } else {
      setHandleClassWithAnim({
        line1: '',
        line2: '',
        line3: '',
      });
      setTimeout(
        () =>
          setHandleClassWithAnim({
            line1: styles.line1Active_reverse,
            line2: styles.line2Active_reverse,
            line3: styles.line3Active_reverse,
          }),
        10,
      );
    }
  }, [isOpenMenu]);
  return (
    <div aria-hidden="true" className={styles.hamburger} onClick={handleClick}>
      <div className={classNames(styles.line1, handleClassWithAnim.line1)} />
      <div className={classNames(styles.line2, handleClassWithAnim.line2)} />
      <div className={classNames(styles.line3, handleClassWithAnim.line3)} />
    </div>
  );
};
